import { AfterViewInit, ChangeDetectorRef, Component, Input } from '@angular/core';
import { KENDO_CHARTS } from '@progress/kendo-angular-charts';
interface TemperatureData {
  day: string;
  temperature: number | null;
  color?: string;
}
@Component({
  selector: 'app-kendo',
  imports: [KENDO_CHARTS],
  templateUrl: './kendo.component.html',
  styleUrl: './kendo.component.scss'
})

export class KendoComponent implements AfterViewInit {

  constructor(private cdr: ChangeDetectorRef) { }
  isReady: boolean = false; // 控制圖表顯示的開關
  // @Input() temperatureData: TemperatureData[] = []
  // @Input() plotBands: any[] = []
  @Input() refData: string = ''//平均參考值
  refDataNum: any[] = []; // 平均參考值轉為數字
  historicalExamRecordsData: TemperatureData[] = []; // 用於圖表的歷史紀錄數據
  private _historicalExamRecords: any[] = [];//歷史紀錄數據儲存庫

  @Input() set historicalExamRecords(value: any[]) {
    if (value && value.length > 0) {
      this._historicalExamRecords = value;
      // 將父層的歷史數據去做整理，提取出數字部分並轉換為數字類型的陣列
      this.setHistoricalExamRecordsData(value);
    }
  }

  
  // kendo.component.ts
  temperatureData: TemperatureData[] = [
    { day: 'Mon', temperature: 5, color: '#FF5733' }, // 紅色
    { day: 'Tue', temperature: 12, color: '#33FF57' }, // 綠色
    { day: 'Wed', temperature: 18, color: '#3357FF' }, // 藍色
    { day: 'Thu', temperature: 25, color: '#F333FF' }, // 紫色
    { day: 'Fri', temperature: 22, color: '#FFBD33' }, // 橘色
    { day: 'Sat', temperature: 15, color: '#33FFF3' }, // 青色
    { day: 'Sun', temperature: 8, color: '#8D33FF' }  // 深紫
  ];
  plotBands = [
    { from: 0, to: 10, color: '#E3F2FD', opacity: 0.3 },
    { from: 10, to: 20, color: '#11745e', opacity: 0.3 },
    { from: 20, to: Number.MAX_VALUE, color: '#1bbf9c', opacity: 0.3 }
  ];
  get historicalExamRecords() {
    return this._historicalExamRecords;
  }

  ngAfterViewInit(): void {
    this.changeRefDataToRefDataNum(this.refData);

    setTimeout(() => {
      this.isReady = true;
      this.cdr.detectChanges(); // 強制 Angular 檢查變更

    }, 100);

  }
  // 將 refData 中的數字提取出來並轉換為數字類型的陣列
  changeRefDataToRefDataNum(newRefData: string) {
    this.refDataNum = (this.refData.match(/\d+(\.\d+)?/g) ?? []).map(Number);
  }

  //封裝父層的歷史數據去做整理，提取出數字部分並轉換為數字類型的陣列
  setHistoricalExamRecordsData(records: any[]) {
    this.historicalExamRecordsData = records.map(record => {
      const rValueNum = parseFloat(record.rValue);
      return {
        day: record.bookDate,
        temperature: isNaN(rValueNum) ? null : rValueNum, // 如果轉換失敗，預設為 0
        color: record.warnFlag === '1' ? '#FF5733' : '#33FF57' // 根據警示註記設定顏色
      };
    });
  }
}
